import { render } from "./AllFooter.vue?vue&type=template&id=90478e64&scoped=true"
import script from "./AllFooter.vue?vue&type=script&lang=js"
export * from "./AllFooter.vue?vue&type=script&lang=js"

import "./AllFooter.vue?vue&type=style&index=0&id=90478e64&lang=scss&scoped=true"

import exportComponent from "D:\\Spadej Work\\SPJWEB\\vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-90478e64"]])

export default __exports__